import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import UrlEncode from './pages/UrlEncode'
import Base64 from './pages/Base64'
import JsonFormatter from './pages/JsonFormatter'
import JwtDecoder from './pages/JwtDecoder'
import QrCode from './pages/QrCode'
import UuidGenerator from './pages/UuidGenerator'
import HashGenerator from './pages/HashGenerator'
import ColorPicker from './pages/ColorPicker'
import HtmlEntity from './pages/HtmlEntity'
import Timestamp from './pages/Timestamp'
import TextCase from './pages/TextCase'
import NumberBase from './pages/NumberBase'
import History from './pages/History'
import Settings from './pages/Settings'
import About from './pages/About'
import Pricing from './pages/Pricing'
import Auth from './pages/Auth'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/url-encode" element={<UrlEncode />} />
      <Route path="/base64" element={<Base64 />} />
      <Route path="/json-formatter" element={<JsonFormatter />} />
      <Route path="/jwt-decoder" element={<JwtDecoder />} />
      <Route path="/qr-code" element={<QrCode />} />
      <Route path="/uuid-generator" element={<UuidGenerator />} />
      <Route path="/hash-generator" element={<HashGenerator />} />
      <Route path="/color-picker" element={<ColorPicker />} />
      <Route path="/html-entity" element={<HtmlEntity />} />
      <Route path="/timestamp" element={<Timestamp />} />
      <Route path="/text-case" element={<TextCase />} />
      <Route path="/number-base" element={<NumberBase />} />
      <Route path="/history" element={<History />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/about" element={<About />} />
      <Route path="/pricing" element={<Pricing />} />
    </Routes>
  )
}

export default App
